module.exports = __webpack_public_path__ + "assets/579fa94fd873858aa3b2379d0285012b.jpg";